// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18wkq","label":"styles_label__2_hVV"};